module.exports = __webpack_public_path__ + "img/article_new.2d1e28c1.png";